import { render, staticRenderFns } from "./WorkplaceEdit.vue?vue&type=template&id=18153c18&"
import script from "./WorkplaceEdit.vue?vue&type=script&lang=js&"
export * from "./WorkplaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports